import { FilterElement } from '@/Domain/Entities';
import { FilterFactory } from '@/Application/Services/FilterFactory';
import { LanguagesStore } from '@/Store/modules/LanguagesStore';

const filterFactory = new FilterFactory();

export default class Filter {
    private _filterElements: FilterElement[];
    private _all: any[];

    constructor() {
        this._all = [];
        this._filterElements = [];
    }
    public get filterElements() {
        return this._filterElements;
    }
    public get all() {
        return this._all;
    }

    public setData(data: any[]) {
        this._all = data;
    }
    public setFilterElements(data: any[], metadata?: any) {
        this._filterElements = data.map(filter => filterFactory.createFilterElement(filter, metadata));
    }

    public resetFilterElements() {
        this._filterElements.forEach(filter => filter.reset());
    }
    public get filteredData(): any[] {
        if (!this._all) { return []; }
        const currentLanguage = LanguagesStore.getters.getCurrentLanguage();
        return this._all.filter(element => {
            return !this._filterElements.some(filter => !filter.showElement(element, currentLanguage));
        });
    }
}
